export const CREATE_ASSET = 'CREATE_ASSET'
export const SET_CREATE_ASSET_SUCCESS = 'SET_CREATE_ASSET_SUCCESS'
export const SET_CREATE_ASSET_ERROR = 'SET_CREATE_ASSET_ERROR'
export const SET_CREATE_ASSET_PROCESSING = 'SET_CREATE_ASSET_PROCESSING'
export const SET_DELETE_ASSET_SUCCESS = 'SET_DELETE_ASSET_SUCCESS'
export const SET_DELETE_ASSET_ERROR = 'SET_DELETE_ASSET_ERROR'
export const SET_DELETE_ASSET_PROCESSING = 'SET_DELETE_ASSET_PROCESSING'
export const SET_LIST_ASSETS_SUCCESS = 'SET_LIST_ASSETS_SUCCESS'
export const SET_LIST_ASSETS_ERROR = 'SET_LIST_ASSETS_ERROR'
export const SET_LIST_ASSETS_PROCESSING = 'SET_LIST_ASSETS_PROCESSING'
export const RESET_CREATE_ASSET = 'RESET_CREATE_ASSET'
export const DELETE_ASSET = 'DELETE_ASSET'
export const LIST_ASSETS = 'LIST_ASSETS'

export function createAsset (payload) {
  return {
    type: CREATE_ASSET,
    payload,
  }
}

export function deleteAsset (payload) {
  return {
    type: DELETE_ASSET,
    payload,
  }
}

export function listAssets (payload) {
  return {
    type: LIST_ASSETS,
    payload,
  }
}

export function setDeleteAssetSuccess (asset) {
  return {
    type: SET_DELETE_ASSET_SUCCESS,
    payload: asset,
  }
}

export function setDeleteAssetError ({ error }) {
  return {
    type: SET_DELETE_ASSET_ERROR,
    payload: { error },
  }
}

export function setDeleteAssetProcessing ({ processing = true }) {
  return {
    type: SET_DELETE_ASSET_PROCESSING,
    payload: { processing },
  }
}

export function setCreateAssetSuccess (asset) {
  return {
    type: SET_CREATE_ASSET_SUCCESS,
    payload: asset,
  }
}

export function setCreateAssetError ({ error }) {
  return {
    type: SET_CREATE_ASSET_ERROR,
    payload: { error },
  }
}

export function setCreateAssetProcessing ({ processing = true }) {
  return {
    type: SET_CREATE_ASSET_PROCESSING,
    payload: { processing },
  }
}

export function setListAssetsSuccess (asset) {
  return {
    type: SET_LIST_ASSETS_SUCCESS,
    payload: asset,
  }
}

export function setListAssetsError ({ error }) {
  return {
    type: SET_LIST_ASSETS_ERROR,
    payload: { error },
  }
}

export function setListAssetsProcessing ({ processing = true }) {
  return {
    type: SET_LIST_ASSETS_PROCESSING,
    payload: { processing },
  }
}

export function resetCreateAsset () {
  return {
    type: RESET_CREATE_ASSET,
  }
}
